// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__21c5Q","info":"UpdateTermsInfo_info__261SF"};